import { IconProps } from "../../../types/style";

const StarSpeed = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.69498 2.605L8.39997 4.015C8.49497 4.21 8.74997 4.39499 8.96497 4.43499L10.24 4.64499C11.055 4.77999 11.245 5.37 10.66 5.96L9.66497 6.955C9.49997 7.12 9.40498 7.445 9.45998 7.68L9.74497 8.91C9.96997 9.88 9.44998 10.26 8.59498 9.75L7.39997 9.04C7.18497 8.91 6.82498 8.91 6.60998 9.04L5.41497 9.75C4.55997 10.255 4.03997 9.88 4.26497 8.91L4.54998 7.68C4.60498 7.45 4.50998 7.125 4.34498 6.955L3.34998 5.96C2.76498 5.375 2.95498 4.78499 3.76998 4.64499L5.04497 4.43499C5.25997 4.39999 5.51498 4.21 5.60998 4.015L6.31498 2.605C6.68998 1.84 7.30998 1.84 7.69498 2.605Z"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4 2.5H1"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2.5 9.5H1"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1.5 6H1"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export default StarSpeed;
